export function getJobLink(job) {
    if (job['is_linkout'] && !job['is_schedule']) {
        return job['linkout_url'] || job['fullapp_url'] || job['global_fullapp_url'];
    } else {
        return '/jobs/' + job['id'] + '/' + job['company']['slug'] + '-' + job['slug'];
    }
}

export function redirectToJob(job, trackJobFullAppClick, thankyouUrl) {
    if (job['is_linkout'] && !job['is_schedule']) {
        trackJobFullAppClick(job['id'], getJobLink(job), thankyouUrl);
    }
}